import React, {useEffect, useState} from "react";
import './AlertRules.scss'
import {
    getAlertMeasurementTypes,
    getAlertMessages,
    getAlertRules,
    selectAlertRule
} from "../../store/actions/alertRulesActions";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";
import ThresholdModal from "./ThresholdModal";
import {toggleModal} from "../../store/actions/toggleModalActions";
import AlertRuleModal from "./AlertRuleModal";
import AlertRulesList from "./AlertRulesList";
import AlertThresholdsList from "./AlertThresholdsList";
import MobileAlertRulesList from "./MobileAlertRules/MobileAlertRulesList";
import MobileAddEditModal from "../_common/MobileModals/MobileAddEditModal";

const selector = state => {
    const { language, alertRules, modalState } = state;
    return {
        t: language.translator,
        pending: alertRules.pending,
        alertRules: alertRules.alertRules,
        selected: alertRules.selected,
        alertMessages: alertRules.alertMessages,
        modalState: modalState
    }
};

const AlertRules = () => {
    const dispatch = useDispatch();

    const {
        t, pending, alertRules, selected, modalState
    } = useSelector(selector)

    const [selectedThreshold, setSelectedThreshold] = useState(null)
    const [selectedWarningType, setSelectedWarningType] = useState(null)
    const [warningEnum, setWarningEnum] = useState(null)


    useEffect(() => {
       dispatch(getAlertRules())
       dispatch(getAlertMessages())
       dispatch(getAlertMeasurementTypes())
    },[])

    const openEdit = (item, warning, warningEnum) => {
        setSelectedThreshold(null)
        if(item) {
            setSelectedThreshold(item)
        }
        setSelectedWarningType(warning)
        setWarningEnum(warningEnum)
        dispatch(toggleModal(true, 'Edit Threshold'))
    }

    const toggleEditAlertRule = (item) => {
        dispatch(toggleModal(true, 'Edit Alert Rule'))
        dispatch(selectAlertRule(item))
    }

    if(modalState.isTabletOrMobile) {
        return (
            <>
                <div className="AlertRulesMobile">
                    <div className="mAlertRulesTitle">
                        <span>{t.gettext('Alert Rules')}</span>
                    </div>
                    <div className="mAddNewRuleContainer">
                        <div className="mAddNewRuleTitle">
                            <span>{t.gettext('Add new rule')}</span>
                        </div>
                        <div className="mAddNewRuleIcon">
                            <div className='addAlertRuleBtn'
                                 onClick={() => dispatch(toggleModal(true, 'Add Alert Rule'))}>
                                <span className='material-icons'>add</span>
                            </div>
                        </div>
                    </div>
                    <div className="mAlertsTitle">
                        {t.gettext('Alerts')}
                    </div>
                    <MobileAlertRulesList
                        items={alertRules}
                        editMethod={toggleEditAlertRule}
                    />
                </div>
                <MobileAddEditModal
                    isPanelOpen={modalState.flag && (modalState.modal === 'Add Alert Rule' || modalState.modal === 'Edit Alert Rule')}
                    // edit
                    edit={modalState.modal === 'Edit Alert Rule'}
                    title={modalState.flag && t.gettext(modalState.modal)}
                    closeMethod={() => dispatch(toggleModal(false, ''))}
                >
                    {modalState.flag && modalState.modal === 'Add Alert Rule' && (
                        <AlertRuleModal  responsive />
                    )}
                    {modalState.flag && modalState.modal === 'Edit Alert Rule' && (
                        <AlertRuleModal edit  responsive editThresholdsModal={openEdit} />
                    )}
                </MobileAddEditModal>
            </>
        )
    }

    return (
        <div className="AlertRules">
            <div className="leftContainer">
                <div className="listContainer">
                    <div className="alertRulesHeader">
                        <span>{t.gettext('Alert Rules')}</span>
                        <div className='addAlertRuleBtn' onClick={() => dispatch(toggleModal(true, 'Add Alert Rule'))}>
                            <span className='material-icons'>add</span>
                        </div>
                    </div>
                    {pending
                        ? <div className='page'>
                            <Spinner size={300}/>
                        </div>
                        :
                        <AlertRulesList
                            items={alertRules}
                            editMethod={toggleEditAlertRule}
                            selectItemMethod={selectAlertRule}
                        />
                    }
                </div>

            </div>
            <div className="rightContainer">
                <div className="alertRulesHeader">
                    <span>{t.gettext('Thresholds')}</span>
                </div>
                {selected.alertRule && (
                    <>
                    <AlertThresholdsList
                        item={selected.alertRule}
                        editMethod={openEdit}
                    />
                    </>
                )}
            </div>
            <div className="bottomContainer">
                <ul>
                    <li>
                        {t.gettext('Standard Alert: Indicates a standard situation that requires attention, but is not an immediate threat.')}
                    </li>
                    <li>{t.gettext('Critical Alert: Indicates a situation that requires immediate action, as it may pose a serious threat to plant health or economic infrastructure.')}
                    </li>
                </ul>
            </div>

            {((modalState.flag && modalState.modal === 'Edit Threshold')) &&
                <ThresholdModal
                    threshold={selectedThreshold}
                    warningType={selectedWarningType}
                    warningEnum={warningEnum}
                />
            }

            {(modalState.flag && modalState.modal === 'Add Alert Rule') &&
                <AlertRuleModal />
            }

            {(modalState.flag && modalState.modal === 'Edit Alert Rule') &&
                <AlertRuleModal
                    edit
                />
            }
        </div>
    )
}

export default AlertRules
